import React, { FC, useEffect, useState } from 'react';

import { Magnifier } from '@gravity-ui/icons';
import { Icon, TextInput } from '@gravity-ui/uikit';
import i18n from '@yandex-int/i18n';
import { Channel } from 'client/model/skill';
import * as keyset from 'i18n/SkillsIndex';

import styles from './SearchAppInput.module.scss';

const t = i18n(keyset);

interface Props {
    channel: Channel;
    onChange: (query?: string) => void;
}

export const SearchAppInput: FC<Props> = ({ channel, onChange }) => {
    const [inputValue, setInputValue] = useState<string | undefined>();

    useEffect(() => {
        setInputValue('');
    }, [channel, onChange]);

    const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value || undefined;
        setInputValue(value);
        onChange(value);
    };

    return (
        <TextInput
            className={styles.input}
            value={inputValue || ''}
            onChange={handleSearch}
            placeholder={t('search-by-yaos-apps')}
            startContent={<Icon className={styles.icon} data={Magnifier} />}
            size="xl"
        />
    );
};
